<template>
  <Row>
    <Col>
      <Heading
        :title="lc.title"
        :divider=false
        tag="h3"
      >
        <template #subtitle>
          <p class="mt-3" v-text="lc.description" />
        </template>
      </Heading>
    </Col>
  </Row>
</template>

<script>
import { Heading, Row, Col, useLocale } from '@locaweb/design-system-vue'

export default {
  name: 'FaviconHeading',
  components: {
    Heading,
    Row,
    Col
  },
  setup () {
    const lc = useLocale('site.favicon.faviconCard.faviconHeading')

    return { lc }
  }
}
</script>
